<script setup lang="ts">
import { auth } from '@/firebase-config';
import { signOut, type User } from 'firebase/auth';

const props = defineProps<{
  user: User | null;
}>();

const emit = defineEmits<{
  logout: [];
}>();

function logout() {
  try {
    signOut(auth);
  } catch (error) {
    alert('Error signing out');
  }
}
</script>

<template>
  <div class="user-panel background-secondary">
    <div class="texts fira">
      <p class="aliceblue">{{ user?.displayName }}</p>
      <p class="small faded">{{ user?.email }}</p>
    </div>
    <button class="icon-button" @click="logout">
      <span class="material-symbols-outlined aliceblue icon-normal">logout</span>
    </button>
  </div>
</template>

<style scoped>
.user-panel {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 225px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 15px;
  padding: 0 10px;
  box-sizing: border-box;
  user-select: none;
}

.texts {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 5px;
}
</style>